import { memo, useMemo } from 'react';

import type { TablePaginationConfig } from 'antd';
import { Table } from 'antd';
import classNames from 'classnames';

import { TABLE_TRANSLATIONS } from '@/shared/consts';

import styles from './CustomTable.module.scss';
import type { ICustomTableProps } from './CustomTable.types';

function TableComponent<T extends object>({
  pagination,
  className,
  columns,
  queryNames,
  ...restProps
}: ICustomTableProps<T>) {
  const paginationMemo: TablePaginationConfig | false = useMemo(() => {
    if (!pagination) {
      return false;
    }

    return {
      pageSizeOptions: [10, 20, 50],
      locale: { items_per_page: '' },
      showSizeChanger: Number(pagination?.total) > 10,
      ...pagination,
    };
  }, [pagination]);

  return (
    <Table
      locale={TABLE_TRANSLATIONS}
      columns={columns}
      {...restProps}
      className={classNames(styles.table, className)}
      pagination={paginationMemo}
    />
  );
}

export const CustomTable = memo(<T extends object>(props: ICustomTableProps<T>) => (
  <TableComponent<T> {...props} />
)) as typeof TableComponent & { displayName?: string };

CustomTable.displayName = 'CustomTable';
